export default "Layout components are used to group related content together. The also provide consistent spacing for blocks of content."